import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';
import NotFoundSVG from './404';

const NotFound = () => {
  const {t} = useTranslation('dflcms');

  return (
    <section className="error-404 not-found flex justify-center md:items-center">
      <div className="container page-wrapper  mt-16 lg:mt-24 xl:mt-56">
        <div className=" flex flex-col mx-auto lg:flex-row md:w-9/12 lg:w-11/12 xl:w-10/12">
          <div className="mb-6 md:mb-8 lg:mb-0 lg:w-6/12 lg:pr-[1.875rem]">
            <NotFoundSVG className={'max-w-full'}/>
          </div>
          <div className="lg:w-6/12 lg:pl-[1.875rem] shadow rounded">
            <div className="card-error bg-white h-full flex flex-col justify-center py-8 px-8">
              <div className="flex items-center mb-3.5">
                <svg className="h-[23px] mr-4" xmlns="http://www.w3.org/2000/svg" width="23.963" height="23.981"
                  viewBox="0 0 23.963 23.981">
                  <path id="unlink-solid"
                    d="M21.75,4a6.286,6.286,0,0,0-4.437,1.844L15.844,7.313a6.217,6.217,0,0,0-1.781,3.625l2,.25A4.188,4.188,0,0,1,17.25,8.719L18.719,7.25a4.265,4.265,0,1,1,6.031,6.031L23.281,14.75H23.25a4.073,4.073,0,0,1-2.437,1.188l.25,2a6.218,6.218,0,0,0,3.625-1.781l1.469-1.469A6.266,6.266,0,0,0,21.75,4ZM7.719,6.281,6.281,7.719l4,4,1.438-1.437Zm3.219,7.781a6.217,6.217,0,0,0-3.625,1.781L5.844,17.313a6.253,6.253,0,1,0,8.844,8.844l1.469-1.469a6.218,6.218,0,0,0,1.781-3.625l-2-.25a4.188,4.188,0,0,1-1.187,2.469L13.281,24.75A4.265,4.265,0,1,1,7.25,18.719L8.719,17.25H8.75a4.073,4.073,0,0,1,2.438-1.187Zm10.781,6.219-1.437,1.438,4,4,1.438-1.437Z"
                    transform="translate(-4.019 -4)" fill="#001786"></path>
                </svg>
                <span className="block text-purple-dark font-bold text-2xl">
                  {t('error.sorry')}
                </span>
              </div>
              <span className="block text-purple-dark opacity-90 md:text-lg">
                {t('error.notFoundPage')}
              </span>
              <span
                className="block text-purple-dark opacity-90 md:text-lg">
                {t('error.youCanGo')}
                <a className="font-bold text-magenta hover:opacity-75" href="/">
                  {t('error.mainPage')}
                </a>{t('error.ofSite')}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );

};

export default memo(NotFound);
